(function () {
  function initArkArticleShare() {
    document.querySelectorAll('[data-ark-share]').forEach((btn) => {
      if (btn.dataset.arkShareInit === 'true') return;
      btn.dataset.arkShareInit = 'true';

      btn.addEventListener('click', () => {
        const url = btn.dataset.shareUrl;
        if (!url) return;

        if (btn.dataset.shareType === 'mail') {
          window.location.href = url;
          return;
        }

        window.open(url, '_blank', 'noopener,noreferrer');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArkArticleShare);
  } else {
    initArkArticleShare();
  }
})();
